import FilterListIcon from '@mui/icons-material/FilterList';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import Badge from '@mui/material/Badge';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { ColumnsPanelTrigger, FilterPanelTrigger } from '@mui/x-data-grid-premium';
import { GlobalHotKeys } from 'react-hotkeys';

import { ModelModuleChip } from '#components/model-module-chip/model-module-chip.js';
import { NetChip } from '#components/net-chip/net-chip.js';

export type SubtableToolbarProps = {
	title?: string;
	subtitle?: string;
	net?: string;
	// Optional toggle buttons for filtering
	showActiveToggle?: boolean;
	showActiveOnly?: boolean;
	onActiveToggle?: () => void;
	referenceDesignator?: string;
	activeSummary?: { active: number; inactive: number; unresolved: number };
};

export function SubtableToolbar({
	title,
	subtitle,
	net,
	referenceDesignator,
	showActiveToggle = false,
	showActiveOnly = false,
	onActiveToggle,
	activeSummary,
}: SubtableToolbarProps) {
	return (
		<div className='flex items-center justify-between border-b border-gray-a4 px-3 py-2'>
			<div className='flex items-center gap-2'>
				{referenceDesignator !== undefined && <ModelModuleChip moduleReferenceDesignator={referenceDesignator} />}
				{net !== undefined && net !== '' && <NetChip net={net} />}
				{showActiveToggle && onActiveToggle && activeSummary && (
					<>
						<GlobalHotKeys
							keyMap={{
								toggleActive: 'r a',
							}}
							handlers={{
								toggleActive: onActiveToggle,
							}}
						/>
						<FormControlLabel
							control={
								<Switch
									checked={showActiveOnly}
									onChange={onActiveToggle}
									color='success'
									slotProps={{
										input: {
											style: { margin: 0, left: 0, width: '100%' },
										},
									}}
								/>
							}
							label={`Applicable Thresholds: ${activeSummary.active}`}
							className='m-0 ml-1'
						/>
					</>
				)}
			</div>
			<div className='flex items-center gap-2'>
				<div className='flex flex-col gap-1'>
					<Typography className='text-sm font-medium'>{title}</Typography>
					{subtitle !== undefined && subtitle !== '' && (
						<Typography className='text-gray-600 mt-1 text-xs'>{subtitle}</Typography>
					)}
				</div>
			</div>
			<div className='flex items-center gap-2'>
				<Tooltip title={<p>Columns</p>}>
					<ColumnsPanelTrigger render={(props) => <IconButton {...props} size='small' />}>
						<ViewColumnIcon fontSize='small' />
					</ColumnsPanelTrigger>
				</Tooltip>

				<Tooltip title={<p>Filters</p>}>
					<FilterPanelTrigger
						render={(props, state) => (
							<IconButton {...props} size='small'>
								<Badge badgeContent={state.filterCount} color='primary' variant='dot'>
									<FilterListIcon fontSize='small' />
								</Badge>
							</IconButton>
						)}
					/>
				</Tooltip>
			</div>
		</div>
	);
}
